export default __webpack_public_path__ + "static/media/AngusVERIFIED.b0b6e96f.png";